import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingLogo from "../../components/onboarding/OnboardingLogo";
import { onboardingShell, card } from "../../components/onboarding/styles";

const SUPPORT_PHONE = "+91 9545640658"; // formatted display; env-driven helper line.

export default function WelcomePage() {
  const navigate = useNavigate();
  const [name] = useState(() => sessionStorage.getItem("onboarding_name") || "friend");
  const [, setAnimationDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAnimationDone(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const exploreDashboard = () => {
    sessionStorage.removeItem("onboarding_email");
    sessionStorage.removeItem("onboarding_name");
    navigate("/executive");
  };

  const Step = ({ n, active, title, body, last }) => (
    <div style={{ display: "flex", gap: 16, marginBottom: last ? 0 : 24 }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div
          style={{
            width: 32, height: 32, borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontWeight: 700, fontSize: 14, flexShrink: 0,
            background: active ? "#059669" : "white",
            color: active ? "white" : "#6B7280",
            border: active ? "none" : "2px solid #D1D5DB",
          }}
        >
          {n}
        </div>
        {!last && (
          <div
            style={{
              width: 2, flex: 1, minHeight: 40, marginTop: 4,
              background: "repeating-linear-gradient(to bottom, #D1D5DB 0px, #D1D5DB 4px, transparent 4px, transparent 8px)",
            }}
          />
        )}
      </div>
      <div style={{ paddingTop: 4 }}>
        <p style={{ fontWeight: 700, fontSize: 14, color: "#1E3A5F", marginBottom: 4, marginTop: 0 }}>{title}</p>
        <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.5, margin: 0 }}>{body}</p>
      </div>
    </div>
  );

  return (
    <div data-testid="welcome-page" style={onboardingShell}>
      <div style={{ marginBottom: 32 }}><OnboardingLogo /></div>

      <svg width="80" height="80" viewBox="0 0 80 80" data-testid="welcome-checkmark">
        <circle cx="40" cy="40" r="36" fill="#059669" opacity="0" style={{ animation: "core-fillCircle 0.1s ease-out 0.6s forwards" }} />
        <circle
          cx="40" cy="40" r="36"
          fill="none" stroke="#059669" strokeWidth="3"
          style={{ strokeDasharray: 226, strokeDashoffset: 226, animation: "core-drawCircle 0.7s ease-out forwards" }}
        />
        <polyline
          points="22,42 34,54 58,26"
          fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
          style={{ strokeDasharray: 50, strokeDashoffset: 50, animation: "core-drawCheck 0.4s ease-out 0.7s forwards" }}
        />
      </svg>

      <h1 style={{ color: "#1E3A5F", fontSize: 26, fontWeight: 700, textAlign: "center", marginTop: 24, marginBottom: 0 }}>
        You are all set
      </h1>
      <h3 data-testid="welcome-name" style={{ color: "#059669", fontSize: 20, fontWeight: 700, textAlign: "center", marginTop: 4, marginBottom: 0 }}>
        Welcome, {name}!
      </h3>
      <p style={{ color: "#6B7280", fontSize: 16, textAlign: "center", marginTop: 8, marginBottom: 0, maxWidth: 480 }}>
        Our team will call you within 24 hours to set up your dashboard.
      </p>

      <div style={{ ...card, width: 500, maxWidth: "100%", padding: 32, marginTop: 32 }}>
        <h3 style={{ color: "#1E3A5F", fontSize: 16, fontWeight: 700, marginTop: 0, marginBottom: 24 }}>What happens next</h3>
        <Step n={1} active title="Our team calls you within 24 hours"
              body="We connect your Tally, GST portal, and other data sources. No technical work needed from you." />
        <Step n={2} title="Your dashboard goes live"
              body="Your real business data appears in your C-ORE dashboard." />
        <Step n={3} title="Get daily insights"
              body="Smart alerts, AI questions, and your business health score every morning." last />
      </div>

      <p style={{ color: "#6B7280", fontSize: 13, textAlign: "center", marginTop: 24, marginBottom: 0 }}>
        Questions? Call or WhatsApp: <span data-testid="welcome-support-phone" style={{ color: "#1E3A5F", fontWeight: 600 }}>{SUPPORT_PHONE}</span>
        <br />Available Monday to Saturday 9am to 7pm IST.
      </p>

      <button
        data-testid="welcome-explore"
        onClick={exploreDashboard}
        style={{
          background: "#059669", color: "white", border: "none", borderRadius: 8,
          padding: "14px 32px", fontSize: 15, fontWeight: 700, cursor: "pointer",
          marginTop: 16,
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = "#047857"; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = "#059669"; }}
      >
        Explore Demo Dashboard
      </button>
      <p style={{ color: "#9CA3AF", fontSize: 12, textAlign: "center", marginTop: 8 }}>
        Your real data will appear here after the setup call.
      </p>

      <style>{`
        @keyframes core-drawCircle { from { stroke-dashoffset: 226; } to { stroke-dashoffset: 0; } }
        @keyframes core-drawCheck  { from { stroke-dashoffset: 50; } to { stroke-dashoffset: 0; } }
        @keyframes core-fillCircle { from { opacity: 0; } to { opacity: 1; } }
      `}</style>
    </div>
  );
}
